import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import { Tooltip } from "reactstrap";
import axios from "axios";
// Import Images
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
  Button,
} from "reactstrap";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

//Import actions
import {
  getLivreurs as onGetLivreurs,
  addNewLivreur as onAddNewLivreur,
  updateLivreur as onUpdateLivreur,
} from "../../../store/actions";
//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";
import TooltipComponent from "../../../Components/Common/TooltipComponent";

const Livreur = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [formData1, setFormData1] = useState({});

  const fetchDataDetail = async () => {
    try {
      const livreurList = await axiosInstance.get(`/livreurlist/`);
    //   console.log("livreurlist: ", livreurList);
      if (livreurList?.data) {
        setLivreurs(livreurList.data.data);
      }
    } catch (err) {
    //   console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDataDetail();
  }, []);

  const [isEdit, setIsEdit] = useState(false);
  const [isEditPhone, setIsEditPhone] = useState(false);
  const [driverSelected, setDriverSelected] = useState(null);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [livreur, setLivreur] = useState([]);
  const [livreurs, setLivreurs] = useState([]);

  //delete Conatct
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalMotif, setModalMotif] = useState(false);

  const handleClickViewMotif = (etat, motifs) => {
    if (etat === "Desactiver" && motifs != null) {
      alert(motifs);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setLivreur(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const onClickDelete = (Livreur) => {
    setLivreur(Livreur);
    setDeleteModal(true);
  };

  // Add Data
  const handleLivreurClicks = () => {
    setLivreur("");
    setIsEdit(false);
    setIsEditPhone(false);
    toggle();
  };

  const dateFormat = () => {
    var d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    return d.getDate() + " " + months[d.getMonth()] + ", " + d.getFullYear();
  };

  const timeFormat = () => {
    let d = new Date();
    let minutes =
      d.getMinutes().toString().length === 1
        ? "0" + d.getMinutes()
        : d.getMinutes();
    let hours = d.getHours().toString() % 12 || 12;
    hours = hours <= 9 ? (hours = "0" + hours) : hours;
    let ampm = d.getHours() >= 12 ? "PM" : "AM";
    return hours + ":" + minutes + ampm;
  };

  const [imgPieceId, setImgPieceId] = useState(null);
  const [imgAttestationResidence, setImgAttestationResidence] = useState(null);
  const [imgPermis, setImgPermis] = useState(null);
  const [imgPhoto, setImgPhoto] = useState(null);
  const [imgAssurance, setImgAssurance] = useState(null);
  const [imgVisite, setImgVisite] = useState(null);
  const [imgEngin, setImgEngin] = useState(null);

  const [cg, setCg] = useState();
  const [file2, setFile2] = useState();
  const [file3, setFile3] = useState();
  const [file4, setFile4] = useState();
  const [file5, setFile5] = useState();
  const [file6, setFile6] = useState();
  const [file7, setFile7] = useState();
  function handlepiece(e) {
  //   console.log(e.target.files);
    setCg(URL.createObjectURL(e.target.files[0]));
  }
  function handleattestation(e) {
  //   console.log(e.target.files);
    setFile2(URL.createObjectURL(e.target.files[0]));
  }
  function handlepermis(e) {
  //   console.log(e.target.files);
    setFile3(URL.createObjectURL(e.target.files[0]));
  }
  function handlephoto(e) {
  //   console.log(e.target.files);
    setFile4(URL.createObjectURL(e.target.files[0]));
  }

  function handleassurance(e) {
  //   console.log(e.target.files);
    setFile5(URL.createObjectURL(e.target.files[0]));
  }
  function handlevisite(e) {
  //   console.log(e.target.files);
    setFile6(URL.createObjectURL(e.target.files[0]));
  }
  function handleengin(e) {
  //   console.log(e.target.files);
    setFile7(URL.createObjectURL(e.target.files[0]));
  }

  // Update Data
  const handleLivreurClick = useCallback(
    (arg) => {
      const Livreur = arg;

      setLivreur({
        id: Livreur.id,
        user_id: Livreur.user_id,
        first_name: Livreur.first_name,
        last_name: Livreur.last_name,
        email: Livreur.email,
        telephone: Livreur.telephone,
        password: Livreur.password,
        independant: Livreur.independant,
        type_conducteur: Livreur.type_conducteur,
        statut: Livreur.statut,
        etat: Livreur.etat,
        code_parrain: Livreur.code_parrain,
        // piece_identite: Livreur.piece_identite,
        // attestation_residence: Livreur.attestation_residence,
        // permis: Livreur.permis,
        // photo: Livreur.photo,
        marque: Livreur.marque,
        modele: Livreur.modele,
        immatriculation: Livreur.immatriculation,
        type_engin: Livreur.type_engin,
        climatisation: Livreur.climatisation,
        chassie: Livreur.chassie,
        nbr_place: Livreur.nbr_place,
        // assurance: Livreur.assurance,
        // visite_technique: Livreur.visite_technique,
        // photo_engin: Livreur.photo_engin
      });

      toggle();
    },
    [toggle]
  );

  // Column
  const columns = useMemo(
    () => [
      // {
      //   Header: <input type="checkbox" id="checkBoxAll" onClick={ () => checkedAll() } />,
      //   Cell: ( cellProps ) =>
      //   {
      //     return <input type="checkbox" name="id" className="Livreur" value={ cellProps.row.original.id } />;
      //   },
      //   id: '#',
      // },
      {
        Header: props.t("Last Name"),
        accessor: "last_name",
        filterable: false,
      },
      {
        Header: props.t("First Name"),
        accessor: "first_name",
        filterable: false,
      },
      {
        Header: props.t("Email"),
        accessor: "email",
        filterable: false,
      },
      {
        Header: props.t("Téléphone"),
        accessor: "telephone",
        filterable: false,
        // Cell: (telephone) => (
        //   <>
        //     {telephone.row.original.telephone}
        //     <Link
        //       to="#"
        //       className="text-warning d-inline-block"
        //       onClick={() => {
        //         const Livreur = telephone.row.original;
        //         handleLivreurClick(Livreur);
        //         toggle();
        //         setIsEditPhone(true);
        //         setIsEdit(false);
        //       }}
        //     >
        //       <i className="ri-pencil-fill align-top"></i>
        //     </Link>
        //   </>
        // ),
      },
      {
        Header: props.t("Livreur"),
        accessor: "independant",
        filterable: false,
        Cell: (livreur) => (
          <span
            className={
              livreur.row.original.independant === 1
                ? "badge badge-soft-success me-1"
                : "badge badge-soft-danger me-1"
            }
          >
            {livreur.row.original.independant === 1 ? "Indépendant" : "Maison"}
          </span>
        ),
      },
      {
        Header: props.t("Etat"),
        accessor: "etat",
        filterable: false,
        Cell: (livreur) => (
          <span
            className={
              livreur.row.original.etat === "Activer"
                ? "badge badge-soft-success me-1"
                : livreur.row.original.etat === "Desactiver"
                ? "badge badge-soft-danger me-1"
                : "badge badge-soft-warning me-1"
            }
            role="button"
            onClick={() =>
              handleClickViewMotif(
                livreur.row.original.etat,
                livreur.row.original.motifs
              )
            }
          >
            {livreur.row.original.etat}
          </span>
        ),
      },
      {
        Header: props.t("Statut"),
        accessor: "statut",
        filterable: true,
        Cell: (livreur) => (
          <>
            {livreur.row.original.statut === "Online" ? (
              <span className="badge badge-soft-success me-1">En ligne</span>
            ) : (
              <span className="badge badge-soft-danger me-1">Hors ligne</span>
            )}
          </>
        ),
      },
      {
        Header: props.t("Action"),
        Cell: (cellProps) => {
          const livreurData = cellProps.row.original;
          const livreurId = cellProps.row.original.id;
          const [info, setInfo] = useState([]);
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  to={`/livreur/${livreurData.id}`}
                  className="btn btn-sm btn-success d-inline-block"
                  onClick={() => {
                    const Livreur = cellProps.row.original;
                  }}
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li>
              {/* <li className="list-inline-item" title={props.t("Modifier")}>
                <Link
                  to="#"
                  className="btn btn-sm btn-warning d-inline-block"
                  onClick={() => {
                    const Livreur = cellProps.row.original;
                    handleLivreurClick(Livreur);
                    setIsEdit(true);
                    setIsEditPhone(false);
                    toggle();
                  }}
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </Link>
              </li> */}
              {livreurData.etat === "En attente" ? (
                <>
                  <li className="list-inline-item" title={props.t("Activer")}>
                    <Link
                      to="#"
                      className="btn btn-sm btn-success d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const LivreurId = cellProps.row.original.id;
                        handleaccept(LivreurId);
                      }}
                    >
                      <i className="ri-check-line align-bottom"></i>
                    </Link>
                  </li>
                  <li
                    className="list-inline-item"
                    title={props.t("Désactiver")}
                  >
                    <Link
                      to="#"
                      className="btn btn-sm btn-danger d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const livreurId = cellProps.row.original.id;
                        setDriverSelected(livreurId);
                        setModalMotif(true);
                      }}
                    >
                      <i className="ri-close-line align-bottom"></i>
                    </Link>
                  </li>
                </>
              ) : livreurData.etat === "Activer" ? (
                <>
                  <li
                    className="list-inline-item"
                    title={props.t("En attente")}
                  >
                    <Link
                      to="#"
                      className="btn btn-sm btn-warning d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const livreurId = cellProps.row.original.id;
                        handleattente(livreurId);
                      }}
                    >
                      <i className="ri-subtract-line align-bottom"></i>
                    </Link>
                  </li>

                  <li
                    className="list-inline-item"
                    title={props.t("Désactiver")}
                  >
                    <Link
                      to="#"
                      className="btn btn-sm btn-danger d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const livreurId = cellProps.row.original.id;
                        setDriverSelected(livreurId);
                        setModalMotif(true);
                      }}
                    >
                      <i className="ri-close-line align-bottom"></i>
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li
                    className="list-inline-item"
                    title={props.t("En attente")}
                  >
                    <Link
                      to="#"
                      className="btn btn-sm btn-warning d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const livreurId = cellProps.row.original.id;
                        handleattente(livreurId);
                      }}
                    >
                      <i className="ri-subtract-line align-bottom"></i>
                    </Link>
                  </li>
                  <li className="list-inline-item" title={props.t("Activer")}>
                    <Link
                      to="#"
                      className="btn btn-sm btn-success d-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        const livreurId = cellProps.row.original.id;
                        handleaccept(livreurId);
                      }}
                    >
                      <i className="ri-check-line align-bottom"></i>
                    </Link>
                  </li>
                </>
              )}
            </ul>
          );
        },
      },
    ],
    [handleLivreurClick, props]
    // [setInfo, handleLivreurClick, toggle, props, handlerefuse, handleaccept]
  );

  const SUPPORTED_FORMATS = ["image/*"];
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      first_name: (livreur && livreur.first_name) || "",
      last_name: (livreur && livreur.last_name) || "",
      email: (livreur && livreur.email) || "",
      telephone: (livreur && livreur.telephone) || "",
      type_conducteur: (livreur && livreur.type_conducteur) || "Livreur",
      cg: (livreur && livreur.cg) || "",
      code_parrain: (livreur && livreur.code_parrain) || "",
      password: (livreur && livreur.password) || "",
    },
    validationSchema: Yup.object({
      first_name:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner les prénoms")),
      last_name:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner le nom")),
      email:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner l'email")),
      telephone:
        (!isEdit || isEditPhone) &&
        Yup.string().required(
          props.t("Veuillez renseigner le numero de téléphone")
        ),
      type_conducteur:
        !isEdit &&
        !isEditPhone &&
        Yup.string().required(
          props.t("Veuillez renseigner le type de conducteur")
        ),
      cg:
        !isEdit &&
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner la carte grise")),
      password:
        !isEdit &&
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner le mot de passe")),
    }),
    onSubmit: (values) => {
      // console.log("Edit: ", isEdit);
      // console.log("isEditPhone: ", isEditPhone);

      if (isEdit) {
        const updateLivreur = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
        };

        // console.log("updateLivreur:", updateLivreur);
        try {
          const data = axiosInstance
            .put(`/driverinfoupdate/?id=${livreur.user_id}/`, updateLivreur)
            .then((response) => {
              // dispatch(onUpdateLivreur(updateLivreur));
              validation.resetForm();
              toast.success(props.t("Livreur modifié avec succès"), {
                autoClose: 3000,
              });
              fetchDataDetail();
            })
            .catch((error) => {
              toast.error(props.t("Echec de la modification du Livreur"), {
                autoClose: 3000,
              });
            });

          // window.location.reload(true);
        } catch (err) {
          console.error(err);
          toast.error(props.t("Echec de la modification du Livreur"), {
            autoClose: 2000,
          });
        }
        fetchDataDetail();
        setIsEdit(false);
      } else if (isEditPhone) {
        const updatePhoneLivreur = {
          newTelephone: values.telephone,
        };

        // console.log("updatePhoneLivreur:", updatePhoneLivreur);
        // console.log("Livreur.user_id:", livreur.user_id);
        try {
          const data = axiosInstance
            .put(
              `/driverchangephone/?id=${livreur.user_id}/`,
              updatePhoneLivreur
            )
            .then((response) => {
              // dispatch(onUpdateLivreur(updateLivreur));
              validation.resetForm();
              toast.success(
                props.t("Numero de téléphone du Livreur modifié avec succès"),
                { autoClose: 3000 }
              );
              fetchDataDetail();
            })
            .catch((error) => {
              toast.error(
                props.t(
                  "Echec de la modification du numero de téléphone du Livreur"
                ),
                { autoClose: 3000 }
              );
            });

          fetchDataDetail();
          setIsEditPhone(false);
          // window.location.reload(true);
        } catch (err) {
          console.error(err);
          toast.error(props.t("Echec de la modification du Livreur"), {
            autoClose: 2000,
          });
        }
        fetchDataDetail();
      } else {
        const registerData = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          telephone: values.telephone,
          type_conducteur: values.type_conducteur,
          cg: values.cg,
          code_parrainage: values.code_parrain,
          independant: false,
          password: values.password,
        };

        // console.log("registerData: ", registerData);

        try {
          // const data = axios.post( `https://stepnode.inawo.pro/admindriverregister/`, formData ).then( response =>
          const data = axiosInstance
            .post(`/driverregister/`, registerData)
            .then((response) => {
              // console.log("Reponse sauvegarder avec success: ", response);

              history.push("/Livreur");
              setCg(null);
              validation.resetForm();
              toast.success(props.t("Livreur ajouté avec succès"), {
                autoClose: 3000,
              });
              fetchDataDetail();
            });
        } catch (err) {
          console.error(err);
          toast.error(props.t("Echec de l'ajout de la Livreur"), {
            autoClose: 3000,
          });
        }
        fetchDataDetail();
      }
      toggle();
    },
  });

  const validationRefuse = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      motif_refuse: "Pas de motif !",
    },
    validationSchema: Yup.object({
      motif_refuse: Yup.string().required(props.t("Veuillez entrer un motif")),
    }),
    onSubmit: (values) => {
      // console.log("Motif de la désactivation: ", values.motif_refuse);
      // console.log("Compte désactivé: ", driverSelected);

      handlerefuse(driverSelected, values.motif_refuse);

      setModalMotif(false);
      setDriverSelected(null);
    },
  });

  const handleattente = (idLivreur) => {
    axios
      .put(`https://stepnode.inawo.pro/driveretat/?id=${idLivreur}`, {
        etat: "En attente",
        motif: null,
      })
      .then((res) => {
        // console.log(res);
        toast.success("Livreur mis en attente avec succès");
        fetchDataDetail();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erreur lors de la mise en attente du Livreur");
      });
  };

  const handleaccept = (idLivreur) => {
    // axios.put( `https://stepnode.inawo.pro/driveretat/?id=${ e }`, {
    axiosInstance
      .put(`/driveretat/?id=${idLivreur}`, {
        etat: "Activer",
        motif: null,
      })
      .then((res) => {
        // console.log(res);
        toast.success("Livreur activé avec succès");
        fetchDataDetail();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erreur lors de l'activation du Livreur");
      });
  };

  const handlerefuse = (idLivreur, motif) => {
    // axios.put( `https://stepnode.inawo.pro/driveretat/?id=${ e }`, {
    axiosInstance
      .put(`/driveretat/?id=${idLivreur}`, {
        etat: "Desactiver",
        motif: motif,
      })
      .then((res) => {
        // console.log(res);
        toast.success("Livreur désactivé avec succès");
        fetchDataDetail();
      })
      .catch((err) => {
      //   console.log(err);
        toast.error("Erreur lors de la désactivation du Livreur");
      });
  };

  // // Node API
  // useEffect(() => {
  //   if (isLivreurCreated) {
  //     setLivreur(null);
  //     fetchDataDetail();
  //   }
  // }, [
  //   dispatch,
  //   isLivreurCreated,
  // ]);

  const handleValidDate = (date) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  const handleValidTime = (time) => {
    const time1 = new Date(time);
    const getHour = time1.getUTCHours();
    const getMin = time1.getUTCMinutes();
    const getTime = `${getHour}:${getMin}`;
    var meridiem = "";
    if (getHour >= 12) {
      meridiem = "PM";
    } else {
      meridiem = "AM";
    }
    const updateTime =
      moment(getTime, "hh:mm").format("hh:mm") + " " + meridiem;
    return updateTime;
  };

  // Checked All
  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".Livreur");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // SideBar Livreur Deatail

  document.title = props.t("Livreurs | Takci");
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={props.t("livreurs")} pageTitle="Takci" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-end">
                    <div className="flex-shrink-0">
                      <button
                        className="btn add-btn"
                        style={{ background: "#002437", color: "white" }}
                        // onClick={() => {
                        //   setModal(true);
                        // }}
                        onClick={() => {
                          // setModal(true);
                          history.push("/livreur/add");
                        }}
                      >
                        <i className="ri-user-add-line me-1 align-bottom"></i>
                        {props.t("Ajouter Livreur")}
                      </button>{" "}
                      {livreurs.length > 0 && (
                        <button
                          disabled={livreurs.length <= 0}
                          type="button"
                          className="btn"
                          style={{ color: "#eac22f" }}
                          onClick={() => setIsExportCSV(true)}
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                          {props.t("Export")}
                        </button>
                      )}
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={12}>
              <Card id="Livreur">
                <CardBody className="pt-0">
                  <div>
                    {loading ? (
                      <div className="text-center my-5">
                        <Loader style={{ color: "#014c94" }} />
                        <h2>Chargement...</h2>
                      </div>
                    ) : (
                      <>
                        <ExportCSVModal
                          show={isExportCSV}
                          onCloseClick={() => setIsExportCSV(false)}
                          data={livreurs.length > 0 ? livreurs : []}
                        />
                        {livreurs.length > 0 ? (
                          <TableContainer
                            columns={columns}
                            data={
                              livreurs.filter(
                                (livreur) => livreur.etat !== "En attente"
                              ) || []
                            }
                            isGlobalFilter={true}
                            isAddUserList={false}
                            customPageSize={8}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                            handleLivreurClick={handleLivreurClicks}
                          />
                        ) : (
                          <Card>
                            <CardBody className="p-4 border-top border-top-dashed">
                              <h6 className="text-muted text-uppercase fw-semibold mb-4">
                                Aucune donnée disponible
                              </h6>
                            </CardBody>
                          </Card>
                        )}
                      </>
                    )}
                  </div>

                  <Modal
                    id="showModal"
                    style={{ maxWidth: 800 }}
                    isOpen={modal}
                    centered
                  >
                    <ModalHeader className="bg-soft-info p-3">
                      {/* { isEdit === true ? props.t( "Modifier Livreur" ) : props.t( "Ajouter Livreur" ) } */}
                      {isEdit
                        ? props.t("Modifier Livreur")
                        : isEditPhone
                        ? props.t("Modifier le numero")
                        : props.t("Ajouter Livreur")}
                    </ModalHeader>

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <Input type="hidden" id="id-field" />
                        <Row className="g-3">
                          {!isEditPhone && (
                            <>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="last_name"
                                    className="form-label"
                                  >
                                    {props.t("Last Name")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="last_name"
                                    id="last_name"
                                    className="form-control"
                                    placeholder={props.t("Entrez le nom")}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.last_name || ""}
                                    invalid={
                                      validation.touched.last_name &&
                                      validation.errors.last_name
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.last_name &&
                                  validation.errors.last_name ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.last_name}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="first_name"
                                    className="form-label"
                                  >
                                    {props.t("First Name")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="first_name"
                                    id="first_name"
                                    className="form-control"
                                    placeholder={props.t("Entrez les prénoms")}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.first_name || ""}
                                    invalid={
                                      validation.touched.first_name &&
                                      validation.errors.first_name
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.first_name &&
                                  validation.errors.first_name ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.first_name}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div>
                                  <Label htmlFor="email" className="form-label">
                                    {props.t("Email")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="email"
                                    id="email"
                                    className="form-control"
                                    placeholder={props.t("Entrez l'email")}
                                    type="email"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.email || ""}
                                    invalid={
                                      validation.touched.email &&
                                      validation.errors.email
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.email &&
                                  validation.errors.email ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.email}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                            </>
                          )}

                          {(isEditPhone || !isEdit) && (
                            <>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="telephone"
                                    className="form-label"
                                  >
                                    {props.t("Numéro de téléphone")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="telephone"
                                    id="telephone"
                                    className="form-control"
                                    placeholder={props.t(
                                      "Entrez le numéro de téléphone"
                                    )}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.telephone || ""}
                                    invalid={
                                      validation.touched.telephone &&
                                      validation.errors.telephone
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.telephone &&
                                  validation.errors.telephone ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.telephone}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                            </>
                          )}

                          {!isEdit && !isEditPhone && (
                            <>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="type_conducteur"
                                    className="form-label"
                                  >
                                    {props.t("Type conducteur")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="type_conducteur"
                                    id="type_conducteur"
                                    className="form-control"
                                    readOnly
                                    placeholder={props.t(
                                      "Entrez le type conducteur"
                                    )}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.type_conducteur ||
                                      "Livreur"
                                    }
                                    invalid={
                                      validation.touched.type_conducteur &&
                                      validation.errors.type_conducteur
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.type_conducteur &&
                                  validation.errors.type_conducteur ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.type_conducteur}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="code_parrain"
                                    className="form-label"
                                  >
                                    {props.t("Code de parainnage")}
                                  </Label>
                                  <Input
                                    name="code_parrain"
                                    id="code_parrain"
                                    className="form-control"
                                    placeholder={props.t(
                                      "Entrez le code de parainnage"
                                    )}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.code_parrain || ""}
                                    invalid={
                                      validation.touched.code_parrain &&
                                      validation.errors.code_parrain
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.code_parrain &&
                                  validation.errors.code_parrain ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.code_parrain}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div>
                                  <Label className="form-label" htmlFor="cg">
                                    {props.t("Numero de la carte Grise")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form"
                                    id="cg"
                                    name="cg"
                                    // value={validation.values.piece_identite || ""}
                                    onBlur={validation.handleBlur}
                                    onChange={validation.handleChange}
                                    invalid={
                                      validation.errors.cg &&
                                      validation.touched.cg
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.errors.cg &&
                                  validation.touched.cg ? (
                                    <FormFeedback type="invalid">
                                      {props.t(validation.errors.cg)}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div>
                                  <Label
                                    htmlFor="password"
                                    className="form-label"
                                  >
                                    {props.t("Mot de passe")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    name="password"
                                    id="password"
                                    className="form-control"
                                    placeholder={props.t(
                                      "Entrez le mot de passe"
                                    )}
                                    type="text"
                                    validate={{
                                      required: { value: true },
                                    }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.password || ""}
                                    invalid={
                                      validation.touched.password &&
                                      validation.errors.password
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.password &&
                                  validation.errors.password ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.password}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <Button
                            type="button"
                            onClick={() => {
                              setModal(false);
                              fetchDataDetail();
                            }}
                            className="btn-light"
                          >
                            {props.t("Fermer")}
                          </Button>

                          {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetLivreurs); }} > {props.t("Fermer")} </button> */}
                          <Button
                            type="submit"
                            className="btn"
                            style={{ background: "#002437", color: "white" }}
                            id="add-btn"
                          >
                            {isEdit
                              ? props.t("Edit")
                              : isEditPhone
                              ? props.t("Edit")
                              : props.t("Ajouter Livreur")}
                          </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>

                  <Modal
                    id="showModalMotif"
                    style={{ maxWidth: 800 }}
                    isOpen={modalMotif}
                    centered
                  >
                    <ModalHeader className="bg-soft-info p-3">
                      {props.t("Motif de la désativation")}
                    </ModalHeader>

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validationRefuse.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <Input type="hidden" id="id-field" />
                        <Row className="g-3">
                          <Col lg={12}>
                            <div>
                              <Label
                                htmlFor="motif_refuse"
                                className="form-label"
                              >
                                {props.t("Motif")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                name="motif_refuse"
                                id="motif_refuse"
                                className="form-control"
                                placeholder={props.t("Entrez le motif")}
                                type="textarea"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validationRefuse.handleChange}
                                onBlur={validationRefuse.handleBlur}
                                value={
                                  validationRefuse.values.motif_refuse || ""
                                }
                                invalid={
                                  validationRefuse.touched.motif_refuse &&
                                  validationRefuse.errors.motif_refuse
                                    ? true
                                    : false
                                }
                              />
                              {validationRefuse.touched.motif_refuse &&
                              validationRefuse.errors.motif_refuse ? (
                                <FormFeedback type="invalid">
                                  {validationRefuse.errors.motif_refuse}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <Button
                            type="button"
                            onClick={() => {
                              setModalMotif(false);
                              fetchDataDetail();
                            }}
                            className="btn-light"
                          >
                            {props.t("Fermer")}
                          </Button>
                          {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetLivreurs); }} > {props.t("Fermer")} </button> */}
                          <Button
                            type="submit"
                            className="btn btn-primary"
                            id="add-motif-btn"
                            style={{ background: "#002437", color: "white" }}
                          >
                            Envoyer la Motif
                          </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer closeButton={false} />
        </Container>
      </div>
    </React.Fragment>
  );
};

Livreur.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(Livreur));
